export default __webpack_public_path__ + "static/media/mentorBanner.cf8882f9.jpg";